<p-toast position="top-right"></p-toast>
<div class="p-g activity-log">
  <div class="p-g-12">
    <div class="card card-w-title" [ngClass]="{ 'loading': loading }">

      <div *ngIf="loading" class="loader-overlay"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
          styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
      </div>

      <h1 class="req-Title" style="padding-top: 20px; padding-left: 10px;"> {{setLabel("activityLogsLabel")}}</h1>

      <p-table #dt [value]="requests" dataKey="id" styleClass="p-table-customers activity-log-table " [rowHover]="true"
        [rows]="100" [showCurrentPageReport]="true" [loading]="loading" [paginator]="true"
        currentPageReportTemplate="There are {{requests?.length}} records" [filterDelay]="0"
        [globalFilterFields]="['name','country.name','representative.name','status']" class="p-table-tecfolk-fix">

        <ng-template pTemplate="caption">
          <div class="reportMainFilter">


            <div class="reportMainFields">
              <div class="filterFields">
                <span class="fieldTitle" for="">{{setLabel("searchByMembershipIDLabel")}}</span>
                <input pinputtext="" [(ngModel)]="searchValue" autocomplete="off" [placeholder]='setLabel("searchPlaceholderLabel")'
                  type="number" name="searchValue" (keyup)="searchLocal(searchValue)"
                  class="p-inputtext p-corner-all p-state-default p-widget">

              </div>
              <div class="filterFields">
                <span class="fieldTitle" for="">{{setLabel("activityTypeLabel")}}</span>
                <p-dropdown class="p-inputtext" [options]="activityTypeOptions" [placeholder]='setLabel("selectPlaceholderLabel")'
                  name="selectActivityType" [style]="{'width':'100%'}" required [(ngModel)]="activityTypeValue"
                  (ngModelChange)="getActivityLogs()">
                </p-dropdown>
              </div>
              <div class="filterFields">
                <span class="fieldTitle" for="">{{setLabel("activityByLabel")}}</span>
                <p-dropdown class="p-inputtext" [options]="activityByOptions" [placeholder]='setLabel("selectPlaceholderLabel")' name="selectUser"
                  [style]="{'width':'100%'}" required [(ngModel)]="activityByValue" (ngModelChange)="getActivityLogs()">
                </p-dropdown>
              </div>
              <div class="filterFields">
                <span class="fieldTitle">{{setLabel("fromLabel")}}</span>
                <p-calendar class="p-calendar-from" [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true"
                  [(ngModel)]="from" [placeholder]='setLabel("fromDatePlaceholderLabel")' [inputStyle]="{'color':'#ffffff'}" name="joinDate"
                  [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="getActivityLogs()">
                </p-calendar>
              </div>
              <div class="filterFields">
                <span class="fieldTitle">{{setLabel("toLabel")}}</span>
                <p-calendar class="p-calendar-to" [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true"
                  [(ngModel)]="to" [placeholder]='setLabel("toDatePlaceholderLabel")' [inputStyle]="{'color':'#ffffff'}" name="joinDate"
                  [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="getActivityLogs()">
                </p-calendar>
              </div>
              <div class="reportMainBtn">
                <span [pTooltip]='setLabel("clearTooltipLabel")' tooltipPosition="top" class="iconClear" [disabled]="loading" (click)="resetFilter()"> <i
                    class="pi pi-times"></i></span>
              </div>
            </div>
            <div class="reportMainBtn">
              <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" class="iconClear hideOnLaptop" [disabled]="loading" (click)="resetFilter()">
                <i class="pi pi-times"></i></span>
              <!-- <button style="background:#ffffff; color: #0e2031;" (click)="resetFilter()"
                class="p-button p-widget p-state-default p-corner-all p-button-text-only">Clear</button> -->
              <span *ngIf='this.userRole.name === "Admin" || this.userRole.name === "Super Admin"' [pTooltip]='setLabel("exportTooltipLabel")' tooltipPosition="top"
                [disabled]="loading" [disabled]="!isData" (click)="ExportData(requests , 'Activity_Logs_Report')"><i
                  class="fa fa-download"></i></span>
              <!-- <button (click)="ExportData(requests , 'Activity_Logs_Report')"
                style="margin-right: 8px; background-color: #1ab352;"
                class="p-g-5 p-lg-3 p-xl-1 p-button p-widget p-state-default p-corner-all p-button-text-only"
                *ngIf='this.userRole.name === "Admin" || this.userRole.name === "Super Admin"'><i
                  class="fa fa-file-excel-o"></i>&nbsp;Export
              </button> -->
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th style="text-align: left;">{{setLabel("activityDateLabel")}}</th>
            <th style="text-align: left;">{{setLabel("activityTypeLabel")}}</th>
            <th style="text-align: left;">{{setLabel("activityByLabel")}}</th>
            <th style="text-align: left;">{{setLabel("initiatedFromLabel")}}</th>
            <th style="text-align: left;">{{setLabel("membershipNoLabel")}}</th>
            <th style="text-align: left;">{{setLabel("subjectLabel")}}</th>
            <th style="text-align: left;">{{setLabel("scopeLabel")}}</th>
            <th style="text-align: left;">{{setLabel("oldValueLabel")}}</th>
            <th style="text-align: left;">{{setLabel("newValueLabel")}}</th>
          </tr>

        </ng-template>
        <ng-template pTemplate="body" let-requestor>
          <tr class="p-selectable-row ">
            <td style="text-align: left;">
              <div class="req-Lable">{{setLabel("activityDateLabel")}} </div>
              <span>{{ requestor?.createdDateNow | date: 'EEE MMM dd yyyy HH:mm:ss' }}
              </span>
            </td>
            <td style="text-align: left;">
              <div class="req-Lable"> {{ setLabel("activityTypeLabel") }} </div>
              <span class="p-column-title">
                <span>{{requestor.activityType}},</span>
                  <!-- Use *ngFor to iterate over updatedValues array and display subjectType -->
                  <ng-container *ngFor="let updatedValue of requestor.updatedValues; let last = last">
                      <!-- Check if updatedValue.subjectType is not in the excluded list -->
                      <ng-container *ngIf="!isExcludedActivityType(updatedValue.subjectType)">
                          {{ updatedValue.subjectType }}
                          <!-- Add comma after each subjectType if it's not the last one -->
                          <span *ngIf="!last">, </span>
                      </ng-container>
                  </ng-container>
              </span>
          </td>
            <td style="text-align: left;">
              <div class="req-Lable"> {{setLabel("activityByLabel")}}</div>
              <span class="p-column-title">{{requestor.activityBy}}</span>
            </td>
            <td style="text-align: left;">
              <div class="req-Lable">{{setLabel("initiatedFromLabel")}}</div>
              <span class="p-column-title">{{requestor.initiatedFrom}}</span>
            </td>
            <td style="text-align: left;">
              <div class="req-Lable"> {{setLabel("membershipNoLabel")}} </div>
              <span class="p-column-title">{{requestor.entitiyTagNumber}}</span>
            </td>
            <td style="text-align: left;">
              <div class="req-Lable"> {{setLabel("subjectLabel")}} </div>
              <span class="p-column-title">{{requestor.entitiyName}}</span>
            </td>
            <td style="text-align: left;">
              <div class="req-Lable"> {{setLabel("scopeLabel")}} </div>
              <span class="p-column-title">{{requestor.scope }}</span>
            </td>
            <td style="text-align: left;">
              <div class="req-Lable"> {{setLabel("oldValueLabel")}} </div>
              <ng-container *ngIf="formatOldValues(requestor) as formattedNewValues">
                <span *ngFor="let value of formattedNewValues.split(';')">
                  {{ value.trim() }}<br />
                </span>
              </ng-container>
              <!-- <span class="p-column-title">{{ formatOldValues(requestor) }}</span> -->
              <span *ngIf="requestor.activityType === 'Member Settings'" class="p-column-title">{{requestor.oldValue |
                date: 'EEE MMM dd yyyy'}}</span>
              <span *ngIf="requestor.activityType === 'Update Package'"
                class="p-column-title">{{requestor.oldValue}}</span>
              <span *ngIf="requestor.activityType === 'Add Fee'" class="p-column-title">{{requestor.oldValue | date:
                'EEE MMM dd yyyy'}}</span>
              <span *ngIf="requestor.activityType === 'Freeze'" class="p-column-title">{{requestor.oldValue}}</span>
              <span *ngIf="requestor.activityType === 'DeFreeze'" class="p-column-title">{{requestor.oldValue}}</span>
              <span *ngIf="requestor.activityType === 'Deactivate'" class="p-column-title">{{requestor.oldValue}}</span>
              <span *ngIf="requestor.activityType === 'Activate'" class="p-column-title">{{requestor.oldValue}}</span>
              <span *ngIf="requestor.activityType === 'Delete Fee'" class="p-column-title">{{requestor.feesDate}}</span>
            </td>
            <td style="text-align: left;">
              <div class="req-Lable"> {{setLabel("newValueLabel")}} </div>

              <ng-container *ngIf="formatNewValues(requestor) as formattedNewValues">
                <span *ngFor="let value of formattedNewValues.split(';')">
                  {{ value.trim() }}<br />
                </span>
              </ng-container>
              <!-- <span class="p-column-title">{{ formatNewValues(requestor) }}</span> -->
              <span *ngIf="requestor.activityType === 'Member Settings'" class="p-column-title">{{requestor.newValue |
                date: 'EEE MMM dd yyyy'}}</span>
              <span *ngIf="requestor.activityType === 'Update Package'"
                class="p-column-title">{{requestor.newValue}}</span>
              <span *ngIf="requestor.activityType === 'Add Fee'" class="p-column-title">{{requestor.newValue | date:
                'EEE MMM dd yyyy'}}</span>
              <span *ngIf="requestor.activityType === 'Freeze'" class="p-column-title">{{requestor.newValue}}</span>
              <span *ngIf="requestor.activityType === 'DeFreeze'" class="p-column-title">{{requestor.newValue}}</span>
              <span *ngIf="requestor.activityType === 'Deactivate'" class="p-column-title">{{requestor.newValue}}</span>
              <span *ngIf="requestor.activityType === 'Activate'" class="p-column-title">{{requestor.newValue}}</span>
              <span *ngIf="requestor.activityType === 'Subscription Fee'" class="p-column-title">{{requestor.newValue}}</span>
              <span *ngIf="requestor.activityType === 'Subscription'" class="p-column-title">{{requestor.newValue}}</span>
              <span *ngIf="requestor.activityType === 'Petty Cash'" class="p-column-title">{{requestor.newValue}}</span>
              <span *ngIf="requestor.activityType === 'New Package'" class="p-column-title">{{requestor.newValue}}</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" style="text-align:left">{{setLabel("noActivityLogfoundLabel")}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<!-- <p-dialog header="Add Fee" [(visible)]="dialogVisibility">
  <form #feeForm="ngForm" style="height: 250px; width: 570px;">
    <div class="p-g-12 p-md-12">
      <div class="p-inputgroup">
        <p-dropdown [options]="feesOptions" name="status" (onChange)="feeChange()" [style]="{'width':'100%'}" required
          [(ngModel)]="fund.status">
        </p-dropdown>
        <p-dropdown [options]="months" (onChange)="feeChange()" name="months" [style]="{'width':'100%'}" required
          [(ngModel)]="fund.month">
        </p-dropdown>
        <p-dropdown [options]="years" (onChange)="feeChange()" name="year" [style]="{'width':'100%'}" required
          [(ngModel)]="fund.year">
        </p-dropdown>
      </div>
    </div>
    <div class="p-g-12 p-md-12">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">PKR </span>
        <input type="number" style="width: 100% !important;" required pattern="[0-9]+" autocomplete="off" pInputText
          placeholder="Price" name="fundPay" [(ngModel)]="fund.pay" #fundPay="ngModel" (input)="checkfeegreater()"
          [ngClass]="fundPay.invalid && (fundPay.dirty || fundPay.touched) ? 'errorInput' : '' ">
        <span class="p-inputgroup-addon">.00</span>
      </div>
      <div *ngIf="fundPay.invalid && (fundPay.dirty || fundPay.touched)">
        <div *ngIf="fundPay.errors.required" class="errorShow">
          Please Enter Fee Correctly.
        </div>
        <div *ngIf="fundPay.errors.pattern" class="errorShow">
          Please Enter Fee Correctly.
        </div>
      </div>
    </div>
    <p-footer>
      <button (click)="addFund()" [disabled]="!feeForm.valid || feegreater==true || feealreadypaid==true" pButton
        type="button" label="Save" icon="pi pi-save" class="p-button-success"></button>
        <br>
        <br>
        <div class="alert alert-danger">
          <p-message severity="error" text="Fee already paid" *ngIf="feealreadypaid"></p-message>
        </div>
        <div class="alert alert-danger">
          <p-message severity="error" text="You cannot pay more than actual Fee" *ngIf="feegreater"></p-message>
        </div>
    </p-footer>
  </form>
</p-dialog> -->